export default function getShortAgentNameFromEmail(email: string) {
  const fullName = email.substring(0, email.lastIndexOf('@')).split('.');
  return `${fullName[0].charAt(0).toUpperCase()}. ${fullName[1].charAt(0).toUpperCase()}${fullName[1].substring(1)}`;
}
